import { config } from '@abyss/ui/tools/config';
import { useQuery } from '../../tools/useQuery';
import { phoneFormatter, toTitleCase } from '../../common/helpers';
import { getPaanFeature } from '../../tools/features';

export const parseResult = result => {
  const initialState = {};
  let providerData = {};

  if (result && result.providersList) {
    let providerName;
    let providerPrimaryPhoneNumber;
    let providerFaxNumber;
    let providerSpecialityArray;

    providerData = result.providersList.map(provider => {
      if (provider.firstName) {
        const { firstName } = provider;
        const { lastName } = provider;
        providerName = `${lastName}, ${firstName}`;
      } else {
        providerName = provider.providerName;
      }
      if (provider.primaryPhone) {
        providerPrimaryPhoneNumber = phoneFormatter(provider.primaryPhone);
      }
      if (provider.fax) {
        providerFaxNumber = phoneFormatter(provider.fax);
      }
      if (provider.specialtyType) {
        providerSpecialityArray = toTitleCase(
          provider?.specialtyType?.split(',')
        );
      }
      return {
        ...provider,
        name: toTitleCase(providerName),
        address: {
          streetAddress: toTitleCase(provider.address1),
          city: toTitleCase(provider.city),
          state: provider.state,
          zip: provider.zip,
        },
        phone: {
          primaryPhone: providerPrimaryPhoneNumber || '-',
          fax: providerFaxNumber || '-',
        },
        speciality: providerSpecialityArray || '-',
        taxId: provider.federalTaxID || '-',
        npi: provider.providerNPI || '-',
        providerId: provider.ndbMpin || '-',
      };
    });

    return {
      providerData,
      currentPage: result.currentPage,
      pageSize: result.pageSize,
      role: result.role,
      total: result.total,
    };
  }

  return initialState;
};

const getApiUrls = () => {
  const isOcmMigration = getPaanFeature('OCM_MIGRATION');

  if (isOcmMigration) {
    const baseUrl = config('PAAN_STARGATE_OCM_API_URL');
    return {
      nonprod: `${baseUrl}/providerlookup/v2/lookup`,
      prod: `${baseUrl}/uhcppaan-providerlookup/v2/lookup`,
    };
  }

  const baseUrl = config('CORE_PAAN_STARGATE_API_URL');
  return {
    nonprod: `${baseUrl}/providerlookup/v1/lookup`,
    prod: `${baseUrl}/uhcppaan-providerlookup/v1/lookup`,
  };
};

const getApiUrl = () => {
  const env = config('APP_ENV');
  const urls = getApiUrls();
  return env === 'prod' ? urls.prod : urls.nonprod;
};

export const useProviderDataSearch = options => {
  const url = getApiUrl();
  const queryOptions = options;
  queryOptions.isStringify = true;

  const [queryResult, queryAction] = useQuery(url, {
    ...queryOptions,
    onCompleted: result => {
      const data = result.body.data ? result.body.data : result.body;
      queryOptions.onCompleted(parseResult(data));
    },
  });

  const parsedResult = {
    ...queryResult,
    data: parseResult(queryResult.data),
  };

  return [parsedResult, queryAction];
};
